import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import Loading from '../components/Loading';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ Component, path, ...args }) { 
  const { profileLoading, isAuth } = useContext(AuthContext);

  return (
    <Route
      {...args}
      path={path}
      render={({ location }) => {
        if (profileLoading)
          return (
            <Loading />
          );
        if (isAuth) {
          return <Component />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/`,
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
}
